var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "About IST",
      "tabActive": "Company History",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Company History ")])]), _c('top-image', {
    attrs: {
      "src": "/images/sub/about/history/his-img1.png"
    }
  }), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "his-year text-center text-md-left pa-16 pa-md-30 py-lg-60 pl-lg-70 pr-lg-90 line-height-1 color-white mb-6 mb-md-0 mt-30 mt-md-0"
  }, [_c('p', {
    staticClass: "page-text-lg mb-8 mb-lg-20"
  }, [_vm._v(" History of the IST ")]), _c('h2', {
    staticClass: "poppins font-weight-semibold font-size-30 font-size-lg-54 text-md-right d-inline-block d-md-block"
  }, [_vm._v(" 2022"), _c('span', {
    staticClass: "d-inline-block d-md-none mx-6"
  }, [_vm._v("~")])]), _c('h2', {
    staticClass: "poppins font-weight-semibold font-size-30 font-size-lg-54 d-inline-block d-md-block mt-n4"
  }, [_vm._v(" 2012 "), _c('span', {
    staticClass: "d-none d-md-inline-block"
  }, [_vm._v("~")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "pl-md-24 pl-lg-50 pt-md-50 pt-lg-120 his-detail overflow-hidden"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-8 mb-md-24 mb-lg-54"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2022 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" ISO 45001 : 2018 Certificate of Registration "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Health Safety Management System ")])]), _c('div', {
    staticClass: "d-flex align-center mb-8 mb-md-24 mb-lg-54"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2022 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" 3rd Stage of Smart Factory Development "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("(Since 2019) ")])]), _c('div', {
    staticClass: "d-flex align-center mb-8 mb-md-24 mb-lg-54"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2022 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" ISO 27001 : 2013 Certificate of Registration "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Information Security Management System ")])]), _c('div', {
    staticClass: "d-flex align-center mb-8 mb-md-24 mb-lg-54"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2014 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" Change of Company Name "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("(IS Techno Co. Ltd. to IST Co., Ltd.) ")])]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2012 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" ISO 14001 : 2015 Certificate of Registration "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Environmental Management System ")])])])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('top-image', {
    attrs: {
      "src": "/images/sub/about/history/his-img2.png"
    }
  }), _c('v-container', [_c('v-row', {
    staticClass: "flex-column-reverse flex-md-row justify-start"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "pl-md-24 pl-lg-50 pt-md-50 pt-lg-120 his-detail overflow-hidden"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-8 mb-md-24 mb-lg-54"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2008 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" R&D Established (No. 2008110774) ")])]), _c('div', {
    staticClass: "d-flex align-center mb-8 mb-md-24 mb-lg-54"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2007 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" ISO 9001 : 2015 Certificate of Registration "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Quality Management System ")])]), _c('div', {
    staticClass: "d-flex align-center mb-8 mb-md-24 mb-lg-54"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 2003 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" IST USA Inc. U.S Office Established ")])]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40"
  }, [_c('h3', {
    staticClass: "poppins tit line-hieght-1"
  }, [_vm._v(" 1996 ")]), _c('span', {
    staticClass: "d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"
  })]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" IS Techno Ltd. Established ")])])])]), _c('v-col', {
    staticClass: "d-flex justify-md-end",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "his-year text-center text-md-left pa-16 pa-md-30 py-lg-60 pl-lg-70 pr-lg-90 line-height-1 color-white mb-6 mb-md-0 mt-30 mt-md-0"
  }, [_c('p', {
    staticClass: "page-text-lg mb-8 mb-lg-20"
  }, [_vm._v(" History of the IST ")]), _c('h2', {
    staticClass: "poppins font-weight-semibold font-size-30 font-size-lg-54 text-md-right d-inline-block d-md-block"
  }, [_vm._v(" 2008"), _c('span', {
    staticClass: "d-inline-block d-md-none mx-6"
  }, [_vm._v("~")])]), _c('h2', {
    staticClass: "poppins font-weight-semibold font-size-30 font-size-lg-54 d-inline-block d-md-block mt-n4"
  }, [_vm._v(" 1996 "), _c('span', {
    staticClass: "d-none d-md-inline-block"
  }, [_vm._v("~")])])])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }